import { useState, useEffect } from 'react'
import { useRouter } from "../../hooks/router";
import { sing_in, check_email_req } from "../../server/requests";

import ErrorMessage from '../AlertMessage/ErrorMessage'
import { NavLink } from "react-router-dom";
import { generate_id, info_device, translateWord } from "../Util/util";

export default function MessageVerify({
    setPopUpTitles, configs
}) {
    const router = useRouter()


    useEffect(() => {
        if (router.query.n == 'verify') {
            setPopUpTitles('We sent an activation link to  email address you have entered. Please check your email and click on register button.')
        }

    }, []);

    const onSubmit = (e) => {
        e.preventDefault();

        if (router.query.n == 'verify') {
            router.push('/auth/verify-code?n=register')
        }

    }

    const goToHelp = () => {

        let helpUrl = configs?.help_page.replace('{{lang}}', configs?.language.iso_code)

        window.open(helpUrl)
        // window.location.href = helpUrl

    }

    return (
        <>
            <div className="login">
                <form onSubmit={onSubmit} action="">
                    <button type={'submit'} className={'card_color'}>{translateWord('OK', 'OK')}</button>
                    <p>
                        {translateWord('Need help? ', 'Need help? ')}
                        <span onClick={goToHelp}>{translateWord('Go to Help', 'Go to Help')}</span>
                    </p>
                </form>
            </div>
        </>
    )
}